import { Component } from '@angular/core';

@Component({
    selector: 'app-successpass',
    templateUrl: './successpass.component.html',
    styleUrls: ['./successpass.component.scss'],
    standalone: false
})
export class SuccesspassComponent {

}
